<template>
  <div class="AbnormalContentBox" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button class="upBtn" type="primary" @click="submit">{{ btnTitle }}</el-button>
    <el-descriptions class="AbnormalContent" :column="1" border labelClassName="labelClassName">
      <template slot="title">
      </template>
      <el-descriptions-item>
        <template slot="label"> 异常类型 </template>
        <el-radio-group class="chenckBox" v-model="abnormalType" v-if="checkType == 'radio'">
          <div style="text-align: left">
            <!-- oem禁止少件  没入满禁止多件 -->
            <el-radio-button :label="item.value" v-for="item in abnormalOptionList" :key="item.value"
              :disabled="(item.value != '105' && record.isShortage == 1) || (item.value == '105' && record.isShortage != 1) || (item.value == '102' && check_oem == 'check_oem') || ((record.num - Number(record.stockInNum) - Number(record.confirmNum)) > 0 && item.value == '103')">{{
                item.title }}</el-radio-button>
          </div>
        </el-radio-group>
        <el-checkbox-group v-if="checkType == 'checkbox'" v-model="abnormalTypeList">
          <el-checkbox-button v-for="i in abnormalOptionList" :label="i.value" :key="i.value">{{
            i.title
          }}</el-checkbox-button>
        </el-checkbox-group>
        <el-button-group v-if="checkType == 'popBtn'">
          <el-button class="noFocusBtn" :label="item.value" v-for="item in abnormalOptionList" :key="item.value"
            @click="popBtnClick(item.value)"
            :type="exceptionItemDtoList.some(y => y.exceptionCode == item.value) ? 'primary' : ''">
            <el-popover placement="top" trigger="hover" :tabindex="9999" @show="showPop(item.value)">
              <div style="max-width: 400px;">
                <el-radio-group class="chenckBox" v-model="abnormalSeverityCode" @input="degreeChange">
                  <div style="text-align: left">
                    <el-radio-button :label="d.value" v-for="d in degreeList" :key="d.value">{{ d.label
                    }}</el-radio-button>
                  </div>
                </el-radio-group>
              </div>
              <div slot="reference">
                {{ item.title }}
                <span style="color:#fff">-</span>
                {{exceptionItemDtoList.filter(y => y.exceptionCode == item.value)[0]?.desc}}
              </div>
            </el-popover>
          </el-button>
        </el-button-group>

        <span style="color:red;font-weight: bold;margin-left: 10px;font-size: 14px"
          v-if="record.isShortage == 1">该商品采购已提交少件，提交异常后等待采购补充退货地址进行退货</span>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 数量 </template>
        <div>
          <el-input v-model="num" style="width: 300px; margin-right: 10px"></el-input>
          <el-button @click="numAdd(1)">+1</el-button>
          <el-button @click="numAdd(3)">+3</el-button>
          <el-button @click="numAdd(5)">+5</el-button>
          <el-button @click="numAddAll" :disabled="!!abnormalType && (abnormalType == '103' || abnormalType == '105')"
            v-if="record.purchaseNum && record.confirmNum && record.stockInNum">全部</el-button>
        </div>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 体积 </template>
        <el-radio-group v-model="volume" :disabled="!!record.volume">
          <div style="text-align: left">
            <el-radio-button label="XS">超小</el-radio-button>
            <el-radio-button label="S">小</el-radio-button>
            <el-radio-button label="M">中</el-radio-button>
            <el-radio-button label="L">大</el-radio-button>
            <el-radio-button label="XL">超大</el-radio-button>
          </div>
        </el-radio-group>
      </el-descriptions-item>
      <el-descriptions-item v-if="checkType != 'radio' || abnormalType != '105'">
        <template slot="label"> 图片 </template>
        <div class="imageBox" :id="`abnormalUploader${canvasId}`">
          <canvas :id="canvasId" width="100" height="100" />
          <!-- <canvas id="test" width="800" height="400"/> -->
          <div class="imgBlock">
            <div class="preview__li" v-for="(item, index) in images" :key="index">
              <!-- <ImgPreviews :images="[item.imgUrl]" width="100" height="100" /> -->
              <el-tooltip class="item" effect="light" placement="top" :disabled="(!record.imgTagFlag && !record.imgDefectiveTagFlag) || disabledChoose">
                <div slot="content">
                  <div v-if="record.imgTagFlag">
                    <el-checkbox v-model="item.outside" label="表面" border
                      @change="e => changeCheckbox(e, item, 'outside')"></el-checkbox>
                    <el-checkbox v-model="item.inside" label="内里" border
                      @change="e => changeCheckbox(e, item, 'inside')"></el-checkbox>
                  </div>
                  <div style="margin-top: 6px;" v-if="record.imgDefectiveTagFlag">
                    <el-checkbox v-model="item.normal" label="正品" border
                      @change="e => changeCheckbox(e, item, 'normal')"></el-checkbox>
                    <el-checkbox v-model="item.defective" label="次品" border
                      @change="e => changeCheckbox(e, item, 'defective')"></el-checkbox>
                  </div>
                </div>
                <el-image :src="item.imgUrl" :style="{ width: '100px', height: '100px' }"
                  :preview-src-list="[item.imgUrl]" alt="图片" class="previewsImage-tag">
                </el-image>
              </el-tooltip>
              <i class="el-icon-error" @click="delImg(item, index)"></i>
            </div>
            <el-upload class="uploader" :action="actionUrl" :on-change="uploadChange" :before-upload="beforeUpload"
              :data="uploadData" :http-request="uploadToOSS" :file-list="fileList" :show-file-list="false"
              v-if="images.length < 5">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div style="display: flex;flex-direction: column;">
            <el-button style="width: 100px;margin-left: 10px;" @click="getImages">获取图片</el-button>
            <el-button @click="mergeImage" style="margin-top: 10px;width: 100px"
              :disabled="images.length != 2">合并图片</el-button>
          </div>
        </div>
        <div style="color:red;" v-if="record.imgTagFlag">
          注意：入库商品中包含有沼田客户货物，请将异常商品图片标明”表面“或”内里“
        </div>
        <div style="color:red;" v-if="record.imgDefectiveTagFlag && isInhousePage">
          注意：网红店铺，需要额外标记“正品”或“次品”
        </div>
      </el-descriptions-item>
      <el-descriptions-item v-if="checkType != 'radio' || abnormalType != '105'">
        <template slot="label"><span style="color:red" v-if="abnormalTypeList.includes('317') || abnormalTypeList.includes('315')">*</span>备注 </template>
        <el-input maxlength="250" type="textarea" :autosize="{ minRows: 1, maxRows: 3 }" v-model="textarea"
          placeholder="备注" />
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import QRCode from "qrcode";
import ImgPreviews from "@/components/ImgPreviews";
import { uploadAliOSS } from '@/utils/upload'
import {
  getApplyCode,
  imgSave,
  deleteImageApi,
  imgByCode
} from "@/apis/inHouse";
export default {
  components: { ImgPreviews },
  data() {
    return {
      canvasId: Math.random().toFixed(8),
      actionType: "purchase",
      abnormalType: "",
      abnormalTypeList: [],
      exceptionItemDtoList: [],
      abnormalSeverityCode: '',
      degreeVisible: "",
      num: "",
      volume: "",
      qrCode: "",
      images: [],
      textarea: "",

      actionUrl: "http://192.168.103.145/customer/oss/putOSS",
      fileList: [],
      uploadData: {},
      fullscreenLoading: false,
      activeValue: ''
    };
  },
  props: {
    abnormalOptionList: {
      type: Array,
      default: () => [],
    },
    checkType: {
      type: String,
      default: "radio",
    },
    record: {
      type: Object,
      default: () => {
        return {}
      },
    },
    check_oem: {
      type: String,
      default: "",
    },
    btnTitle: {
      type: String,
      default: '确定'
    },
    // 禁止选择表面内里
    disabledChoose: {
      type: Boolean,
      default: false
    }
    // abnormalFormat: {
    //   type: Function
    // }
  },
  watch: {
    qrCode: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (!newVal) {
          return;
        }
        this.$nextTick((_) => {
          let canvas = document.getElementById(this.canvasId);
          QRCode.toCanvas(canvas, newVal, function (error) {
            if (error) console.error(error);
          });
        });
      },
      keep: true,
    },
    record: {
      immediate: true,
      deep: true,
      handler: function (newVal, oldVal) {
        console.log(newVal.volume)
        if (newVal.volume) {
          this.volume = newVal.volume
        }
      },
    },
    abnormalType: {
      immediate: true,
      handler: function (newVal, oldVal) {
        if (!newVal || !oldVal) {
          return;
        }
        if (newVal == '103' || oldVal == '103' || newVal == '105' || oldVal == '105') {
          this.num = ''
        }
      },
      keep: true,
    },
    // abnormalTypeList: {
    //   immediate: true,
    //   handler: function (newVal, oldVal) {
    //     if (!newVal || !oldVal) {
    //       return;
    //     }
    //     this.num = ''
    //   },
    //   keep: true,
    // }
  },
  computed: {
    degreeList: function () {
      // 306 抽丝
      return this.degreeVisible != '306' ? [{
        label: '轻度',
        value: 'lightly'
      }, {
        label: '中度',
        value: 'medium'
      }, {
        label: '重度',
        value: 'serious'
      }] : [
        {
          label: '1-5cm',
          value: '306_1_5'
        },
        {
          label: '6-10cm',
          value: '306_6_10'
        },
        {
          label: '大于10cm',
          value: '306_over10'
        }
      ]
    },
    isInhousePage:function () {
      return this.$route.path.indexOf('inHouse_check') > -1
    }
  },
  methods: {
    changeCheckbox(val, item, k) {
      if (val) {
        if (k === 'inside') {
          item.inside = true
          item.outside = false
        }
        if (k === 'outside') {
          item.inside = false
          item.outside = true
        }
        if (k === 'normal') {
          item.normal = true
          item.defective = false
        }
        if (k === 'defective') {
          item.normal = false
          item.defective = true
        }
      } else {
        item[k] = false
      }

      console.log(this.images)
      imgSave({
        imgDTOList: this.images.map(v => {
          const tagList = []
          const keys = ['outside', 'inside', 'normal', 'defective']
          keys.forEach((keyItem) => {
            if (v[keyItem]) {
              tagList.push(keyItem)
            }
          })
          return ({
            imgUrl: v.imgUrl,
            tagList: tagList
          })
        }),
        operationType: 1,
        picRelation: this.qrCode,
      })
    },
    numAdd(targetNum) {
      console.log(this.abnormalType)
      if (this.abnormalType && (this.abnormalType == '103' || this.abnormalType == '105')) {
        this.num = (Number(this.num) || 0) + targetNum;
        return
      }
      const maxNum = this.record.purchaseNum - Number(this.record.stockInNum) - Number(this.record.confirmNum);
      const targetTotal = (Number(this.num) || 0) + targetNum;
      // this.num = maxNum > targetTotal ? targetTotal : maxNum;
      if (maxNum < targetTotal) {
        this.$message.warning('超过数量上限')
        return
      }
      this.num = targetTotal
    },
    numAddAll() {
      if (this.abnormalType && this.abnormalType == '103') {
        return
      }
      this.num = this.record.purchaseNum - Number(this.record.stockInNum) - Number(this.record.confirmNum)
    },
    getCode() {
      if (this.isreceipt) {
        return;
      }
      let params = {
        num: 1,
      };
      getApplyCode(params).then(({ code, data }) => {
        if (code === 0) {
          this.qrCode = data[0];
        }
      });
    },
    beforeUpload(res) {
      console.log(res);
    },
    uploadChange(res) {
      console.log(res);
    },
    uploadToOSS(res) {
      uploadAliOSS({
        file: res.file,
        path: 'wms/abnormal/',
        bizType: 'wmsAbnormalImage'
      }).then((r) => {
        this.saveImg(r.url)
      })
    },
    saveImg(url) {
      this.fullscreenLoading = true;
      console.log(url, this.qrCode);
      let parmas = {
        picRelation: this.qrCode,
        imgDTOList: [
          {
            imgUrl: url,
            tagList: []
          }
        ]
      };
      imgSave(parmas).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("添加成功");
          this.getImages();
        }
      }).finally(() => {
        this.fullscreenLoading = false;
      });
    },
    getImages: function () {
      imgByCode({ picRelation: this.qrCode }).then(({ code, data }) => {
        if (code === 0) {
          this.images = data.map(v => ({
            ...v,
            outside: v.tagList?.includes('outside'),
            inside: v.tagList?.includes('inside'),
            normal: v.tagList?.includes('normal'),
            defective: v.tagList?.includes('defective')
          }));
        }
      });
    },
    //删除图片
    delImg(record, index) {
      deleteImageApi({
        id: record.id,
      }).then((res) => {
        this.$message.success("删除成功！");
        this.images.splice(index, 1);
      });
    },
    mergeImage() {
      this.fullscreenLoading = true;
      if (this.images.length < 2) {
        return
      }
      let canvas = document.createElement('canvas')
      const img1 = new Image()
      const img2 = new Image()
      const that = this
      const imageLoad1 = new Promise(function (resolve, reject) {
        img1.src = that.images[0].imgUrl
        img1.crossOrigin = ""
        img1.onload = () => {
          resolve()
        }
      })
      const imageLoad2 = new Promise(function (resolve, reject) {
        img2.src = that.images[1].imgUrl
        img2.crossOrigin = ""
        img2.onload = () => {
          resolve()
        }
      })
      Promise.all([imageLoad1, imageLoad2]).then(() => {
        this.fullscreenLoading = true;
        const popHeight = img2.naturalHeight > img1.naturalHeight ? img2.naturalHeight : img1.naturalHeight
        canvas.width = img1.naturalWidth * (popHeight / img1.naturalHeight) + img2.naturalWidth * (popHeight / img2.naturalHeight)
        canvas.height = popHeight
        let target = canvas.getContext('2d')
        target.drawImage(img2, img1.naturalWidth * (popHeight / img1.naturalHeight), 0, img2.naturalWidth * (popHeight / img2.naturalHeight), popHeight)
        target.drawImage(img1, 0, 0, img1.naturalWidth * (popHeight / img1.naturalHeight), popHeight)
        const dataURL = canvas.toDataURL('image/png')
        const name = `imgMerge${new Date().getTime()}.png`
        const file = dataURLtoFile(dataURL, name)

        uploadAliOSS({
          file: file,
          path: 'wms/abnormal/',
          bizType: 'wmsAbnormalImage'
        }).then((r) => {
          this.fullscreenLoading = true;
          deleteImageApi({
            id: that.images[0].id,
          }).then(() => {
            deleteImageApi({
              id: that.images[1].id,
            }).then(() => {
              that.images.splice(0, 2);
              that.saveImg(r.url)
            }).finally(() => {
              this.fullscreenLoading = false;
            });
          }).finally(() => {
            this.fullscreenLoading = false;
          });
        })
      }).catch(() => {
        this.fullscreenLoading = false;
      })

      function dataURLtoFile(dataURL, filename) {
        const arr = dataURL.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
      }
    },
    submit() {
      if (isNaN(this.num) || !Number.isInteger(Number(this.num)) || this.num < 1) {
        this.$message.warning('请输入正确的数量')
        return
      }
      if (this.checkType == 'radio' && !this.abnormalType) {
        this.$message.error("请勾选异常类型");
        return;
      }
      if (this.checkType == 'checkbox' && !this.abnormalTypeList.length) {
        this.$message.error("请勾选异常类型");
        return;
      }
      if (this.checkType == 'popBtn' && !this.exceptionItemDtoList.length) {
        this.$message.error("请勾选异常类型");
        return;
      }
      if (['101', '103'].includes(this.abnormalType) && this.images.length === 0) {
        this.$message.warning("请上传图片");
        return;
      }
      if((this.abnormalTypeList.includes('317') || this.abnormalTypeList.includes('315')) && !this.textarea) {
        this.$message.warning("请填写备注");
        return
      }
      this.$emit('submit', {
        ...this,
        exceptionItemDtoList: this.exceptionItemDtoList.map(v => {
          return {
            exceptionCode: v.exceptionCode,
            abnormalSeverityCode: v.abnormalSeverityCode
          }
        })
      })
    },
    degreeChange(e) {
      if (this.exceptionItemDtoList.every(v => v.exceptionCode != this.degreeVisible)) {
        this.exceptionItemDtoList.push({
          exceptionCode: this.degreeVisible,
          abnormalSeverityCode: e,
          desc: this.degreeList.filter(v => v.value === e)[0].label
        })
        return
      }
      this.exceptionItemDtoList[this.exceptionItemDtoList.findIndex(v => v.exceptionCode == this.degreeVisible)].abnormalSeverityCode = e
      this.exceptionItemDtoList[this.exceptionItemDtoList.findIndex(v => v.exceptionCode == this.degreeVisible)].desc = this.degreeList.filter(v => v.value === e)[0].label
      // this.degreeVisible = undefined
      console.log(e, this.degreeVisible)
    },
    popBtnMouseover(v) {
      return
      console.log(v)
      if( v && this.activeValue !== v) return
      this.degreeVisible = v
      if (this.exceptionItemDtoList.some(y => y.exceptionCode == v)) {
        this.abnormalSeverityCode = this.exceptionItemDtoList.filter(y => y.exceptionCode == v)[0].abnormalSeverityCode
        return
      }
      this.abnormalSeverityCode = undefined
    },
    popBtnClick(v) {
      console.log(v)
      if (this.exceptionItemDtoList.some(y => y.exceptionCode == v)) {
        this.exceptionItemDtoList = this.exceptionItemDtoList.filter(y => y.exceptionCode != v)
        return
      }
      // this.degreeVisible = v
    },
    showPop(v){
      this.degreeVisible = v
      if (this.exceptionItemDtoList.some(y => y.exceptionCode == v)) {
        this.abnormalSeverityCode = this.exceptionItemDtoList.filter(y => y.exceptionCode == v)[0].abnormalSeverityCode
        return
      }
      this.abnormalSeverityCode = undefined
    }
  },
  mounted() {
    this.getCode();
    var target = document.getElementById(`abnormalUploader${this.canvasId}`)
    target.ondragover = function (e) {
      // console.log(e)
      const ev = window.event || e
      ev.preventDefault();
    }
    const that = this
    target.ondrop = function (e) {
      console.log(e)
      const ev = window.event || e
      ev.preventDefault();
      var files = [];
      [].forEach.call(e.dataTransfer.files, function (file) {
        files.push(file)
      }, false)
      if (!files[0]) {
        return
      }
      that.uploadToOSS({ file: files[0] })

      // let fr = new FileReader()
      // fr.readAsDataURL(ev.dataTransfer.files[0])

      // fr.onload = function(){

      // }
    }
  },
};
</script>
<style>
.AbnormalContentBox {
  position: relative;
  padding-top: 30px
}

.upBtn {
  position: absolute;
  top: -10px;
  right: 10px;
}

.AbnormalContent {
  box-sizing: border-box;
}

.el-descriptions-row td {
  border-right: 1px solid #ebeef5 !important;
}

.labelClassName {
  width: 100px;
}

.imageBox {
  display: flex;
}

.imgBlock {
  display: flex;
  /* width: 340px; */
  flex-wrap: wrap;
}

.preview__ul {
  display: flex;
  /* grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 2;
  grid-row-end: 3; */
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  box-sizing: border-box;
}

.preview__li {
  width: 100px;
  height: 100px;
  background: white;
  margin: 5px;
  position: relative;
}

.preview__li .el-icon-error {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 20px;
  cursor: pointer;
}

.uploader {
  border: 1px solid #eee;
  height: 100px;
  width: 100px;
  margin: 5px;
}

.uploader i {
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style>
.noFocusBtn:not(.el-button--primary):hover {
  background: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
}
</style>
